import React from "react";
import { isEmpty } from "lodash";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import { TMainPageLayoutV3 } from "../type";



const MNPG028 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG028.rendered: ", props);

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null; 

    const mapIframeURL = metaDataLanguageVersion("mapIframeURL", props.params?.["contentDetails"].languageVersions);
    
    return (
        <section className="section">
            <div className="map-items">
                <div className="googlemap">
                    <iframe
                        title='contact-map'
                        src={mapIframeURL}
                        style={{ border: "0px" }}
                        allowFullScreen
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        </section>
    )
}

const Component = React.memo(MNPG028, ( prevProps:TMainPageLayoutV3, nextProps:TMainPageLayoutV3 ) => {
    return true;
});

export default Component;
